//NOTE autogenerated by export script
import { ArticleAPIService as ArticleAPIServiceType } from './articleAPI.service'
export const Article: typeof ArticleAPIServiceType = {} as any
import { ContactAPIService as ContactAPIServiceType } from './contactAPI.service'
export const Contact: typeof ContactAPIServiceType = {} as any
import { CountryAPIService as CountryAPIServiceType } from './countryAPI.service'
export const Country: typeof CountryAPIServiceType = {} as any
import { CustomerAPIService as CustomerAPIServiceType } from './customerAPI.service'
export const Customer: typeof CustomerAPIServiceType = {} as any
import { InvoiceAPIService as InvoiceAPIServiceType } from './invoiceAPI.service'
export const Invoice: typeof InvoiceAPIServiceType = {} as any
import { SchriftverkehrAPIService as SchriftverkehrAPIServiceType } from './schriftverkehrAPI.service'
export const Schriftverkehr: typeof SchriftverkehrAPIServiceType = {} as any
import { WarenpositionenAPIService as WarenpositionenAPIServiceType } from './warenpositionenAPI.service'
export const Warenpositionen: typeof WarenpositionenAPIServiceType = {} as any
export {BASE_PATH} from '../variables'
import { ApiModule as ApiModuleType } from '../api.module'
export const ApiModule: typeof ApiModuleType = {} as any
import { AllServices as AllServicesType } from './allService'
export const All: typeof AllServicesType = {} as any